module.exports = __webpack_public_path__ + "static/media/bkg-2-dsk.7d786c07.jpg";